var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 0C2.03902 0 0.5 1.53902 0.5 3.4375V3.48672L12.2977 9.42302C12.7395 9.64533 13.2605 9.64533 13.7023 9.42302L25.5 3.48672V3.4375C25.5 1.53902 23.961 0 22.0625 0H3.9375Z",
    fill: "url(#paint0_linear_5750_4111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 5.5857L14.5451 11.0979C13.5731 11.587 12.4269 11.587 11.4549 11.0979L0.5 5.5857V16.5625C0.5 18.461 2.03902 20 3.9375 20H22.0625C23.961 20 25.5 18.461 25.5 16.5625V5.5857Z",
    fill: "url(#paint1_linear_5750_4111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5750_4111",
    x1: 9.59006,
    y1: 10.0003,
    x2: 12.9404,
    y2: 17.9662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5750_4111",
    x1: 9.59006,
    y1: 10.0003,
    x2: 12.9404,
    y2: 17.9662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.9eb971f92bbbeb9d4f6e6b3f2b20ba01.svg";
export { ForwardRef as ReactComponent };